export default __webpack_public_path__ + "17374ef9af90bd22669afd36841b83ed.svg";